module.exports = __webpack_public_path__ + "img/Game_target_Z-26.d51b20b7.png";